var map = {
	"./premium-img-1.png": "7d74",
	"./premium-img-2.png": "4f6b",
	"./premium-img-3.png": "ae53",
	"./premium-img-4.png": "a938",
	"./premium-img-5.png": "b0ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "559f";